module.exports = __webpack_public_path__ + "static/media/moon.435dfc32.svg";